

const localEnvironment = "localhost"

const testHostEnvironment = "ebook.drivehertztest.net"

const devHostNames = [ localEnvironment, testHostEnvironment ]

export const shouldShowDevtools = () => devHostNames.includes(window.location.hostname)

export const isLocalEnvironment = () => window.location.hostname === localEnvironment

export const isTestEnvironment = () => window.location.hostname === testHostEnvironment